import { render, staticRenderFns } from "./ModalFormularioAreaUniversidad.vue?vue&type=template&id=159f6328"
import script from "./ModalFormularioAreaUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormularioAreaUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports